export const batch = {
  id: 1,
  name: 'test'
};